import LegalPage from "@/components/feature/LegalPage";
import { HERO_IMAGES } from "@/config/heroImages";

export default function TermsPage() {
  return (
    <LegalPage
      crumb="Terms & Conditions"
      image={HERO_IMAGES.terms}
      title="Terms & Conditions"
      updated="1 January 2026"
      intro="These terms govern the packing, moving, shifting and storage services provided by Lahari Packers and Movers, Bengaluru. By booking a service you agree to the terms below."
      blocks={[
        {
          heading: "Scope of service",
          paragraphs: [
            "Lahari Packers and Movers provides packing, loading, moving, unloading, unpacking and storage services for household, commercial and corporate moves within and outside Bengaluru.",
            "The exact scope of your move is recorded in the written estimate or work order shared with you before the move date. Any work outside that scope may attract additional charges, which will be intimated to you before it is performed.",
          ],
        },
        {
          heading: "Quotations and pricing",
          paragraphs: [
            "Estimates are prepared based on the details shared by you, including volume, distance, floor level and packing requirement. Final billing may vary if the actual volume or requirement differs from the information provided.",
            "All prices are quoted in Indian Rupees. Taxes and any statutory charges, where applicable, will be shown separately on the invoice.",
          ],
          list: [
            "Written item-wise estimate before the move",
            "No hidden charges added after loading",
            "Advance booking amount as mutually agreed",
            "Balance payable on completion of delivery",
          ],
        },
        {
          heading: "Customer responsibilities",
          paragraphs: [
            "Customers are requested to declare all high value, fragile and restricted items before packing begins. Documents, cash, jewellery, and other valuables should be carried personally and not included in the move.",
            "You are responsible for arranging parking access, lift permissions and society or building clearances at both the origin and destination unless we have agreed otherwise in writing.",
          ],
        },
        {
          heading: "Packing, transit and delivery",
          paragraphs: [
            "Goods are packed using our standard material including cartons, bubble wrap, foam and crates. Items packed by the customer will be handled with care but are outside our packing responsibility.",
            "Delivery timelines are indicative and may be affected by traffic restrictions, weather, strikes, vehicle breakdown or other events beyond our reasonable control. We will keep you informed of any change in schedule.",
          ],
        },
        {
          heading: "Liability and claims",
          paragraphs: [
            "We handle every move with trained crews and quality material. Any visible loss or damage must be recorded on the delivery challan at the time of unloading and reported to our team within 48 hours with photographs.",
            "Claims will be assessed as per the terms of the work order and the transit cover selected, if any. We are not liable for delays or losses arising from circumstances beyond our control.",
          ],
        },
        {
          heading: "Cancellation and rescheduling",
          paragraphs: [
            "Moves can be rescheduled or cancelled by informing us in advance. Cancellations made after the crew and vehicle have been dispatched may attract charges for costs already incurred.",
            "Storage bookings are billed for the period occupied, with any unused prepaid period adjusted as per the agreed terms.",
          ],
        },
        {
          heading: "Governing law",
          paragraphs: [
            "These terms are governed by the laws of India. Any dispute shall be subject to the exclusive jurisdiction of the courts at Bengaluru, Karnataka.",
          ],
        },
      ]}
    />
  );
}